import { CheckCircleOutline, ErrorOutline, PersonRemove } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  Divider,
  FormHelperText,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography
} from '@mui/material';
import { useTheme } from '@mui/system';
import { Form } from 'formik';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
// import { useEffect } from 'react';
import { gridSpacing } from 'store/constant';
// import OrganizationFormView from 'ui-component/cards/Skeleton/OrganizationFormView';
// import DocumentUpload from 'ui-component/file-upload';

const SubscriptionChangeModalForm = ({
  errors,
  //   touched,
  //   handleChange,
  values,
  handleSubmit,
  setFieldValue,
  handleClose,
  subscriptionList,
  isLoadingSubscriptionList,
  //   handleBlur,
  isLoadingCallChangeSubscriptonUser
}) => {
  // console.log('subscriptionList : ', subscriptionList);
  const theme = useTheme();
  function EnhancedTableEmployeeDetailsHead() {
    const org_columns = [
      { id: 'user_name', label: 'User Name', align: 'center' },
      {
        id: 'action',
        label: 'Action',
        // minWidth: 150,
        align: 'center'
        // format: (value) => value.toLocaleString('en-US')
      }
    ];

    return (
      <TableHead>
        <TableRow>
          {org_columns?.map((headCell) => (
            <TableCell key={headCell.id} align="center">
              <TableSortLabel className="hover-color-white">{headCell.label}</TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  const [globalUser, setGlobalUser] = useState(null);
  const [localUser, setLocaUser] = useState(null);
  const [isValid, setIsValid] = useState({ global: false, local: false });

  useEffect(() => {
    if (subscriptionList) {
      if (subscriptionList?.localUsers && subscriptionList?.localUsers?.users && Array.isArray(subscriptionList?.localUsers?.users)) {
        setLocaUser(subscriptionList?.localUsers);
      } else {
        setLocaUser(null);
      }

      if (subscriptionList?.globalUsers && subscriptionList?.globalUsers?.users && Array.isArray(subscriptionList?.globalUsers?.users)) {
        setGlobalUser(subscriptionList?.globalUsers);
      } else {
        setGlobalUser(null);
      }
    }
  }, [subscriptionList]);

  /*console.log(
    'ChangeGlobalUser : ',
    globalUser,
    ' | localUser : ',
    localUser,
    ' | isValid : ',
    isValid,
    ' | For submit : ',
    isValid.global && isValid.local
  );*/
  // isValid.global && isValid.local
  useEffect(() => {
    // debugger;
    if (globalUser) {
      if (globalUser?.globalUserCountDifference && Array.isArray(values.deletedGlobalUser) && Array.isArray(globalUser.users)) {
        if (globalUser?.globalUserCountDifference <= values.deletedGlobalUser.length) {
          // if (globalUser?.globalUserCountDifference >= globalUser.users.length) {
          setIsValid((prev) => ({ ...prev, global: true }));
        } else {
          setIsValid((prev) => ({ ...prev, global: false }));
        }
      }
    } else {
      setIsValid((prev) => ({ ...prev, global: true }));
    }
    if (localUser) {
      if (localUser?.localUserCountDifference && Array.isArray(values.deletedLocalUser) && Array.isArray(localUser.users)) {
        if (localUser?.localUserCountDifference <= values.deletedLocalUser.length) {
          // if (localUser?.localUserCountDifference >= localUser.users.length) {
          setIsValid((prev) => ({ ...prev, local: true }));
        } else {
          setIsValid((prev) => ({ ...prev, local: false }));
        }
      }
    } else {
      setIsValid((prev) => ({ ...prev, local: true }));
    }
  }, [globalUser, localUser]);

  const onRemoveUser = (id, type) => {
    if (id) {
      if (type === 'global') {
        if (globalUser?.users && Array.isArray(globalUser?.users) && globalUser?.users?.length) {
          let newGlobalUserArr = globalUser?.users?.filter((user) => {
            if (id !== user?.id) return true;
          });
          if (newGlobalUserArr && Array.isArray(newGlobalUserArr)) {
            setFieldValue('deletedGlobalUser', [...values.deletedGlobalUser, id]);
            setGlobalUser((prev) => ({ ...prev, users: newGlobalUserArr }));
          }
        }
      }
      if (type === 'local') {
        // setFieldValue('deletedLocalUser', [...values.deletedLocalUser, id]);
        if (localUser?.users && Array.isArray(localUser?.users) && localUser?.users?.length) {
          let newLocalUserArr = localUser?.users?.filter((user) => {
            if (id !== user?.id) return true;
          });
          if (newLocalUserArr && Array.isArray(newLocalUserArr)) {
            setFieldValue('deletedLocalUser', [...values.deletedLocalUser, id]);
            setLocaUser((prev) => ({ ...prev, users: newLocalUserArr }));
          }
        }
      }
    }
  };

  return (
    <>
      {isLoadingSubscriptionList ? (
        <CircularProgress
          size={50}
          sx={{
            // color: '#16B1FF',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px'
          }}
        />
      ) : (
        <Form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={gridSpacing} style={{ alignContent: 'center', minHeight: '400px' }}>
            <Grid item xs={12}>
              <Grid container spacing={gridSpacing}>
                {globalUser && (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <h2>Global User</h2>
                    <h3 style={{ marginBottom: 0, marginTop: '5px' }}>Current Plan Count : {globalUser?.previousGlobalUserCount}</h3>
                    <h3 style={{ marginBottom: 0, marginTop: '5px' }}>Chosen Plan Count : {globalUser?.currentGlobalUserCount}</h3>
                    <h3 style={{ marginBottom: 0, marginTop: '5px' }}>
                      You need to remove {globalUser?.globalUserCountDifference} user(s) from this list &nbsp;{' '}
                      {isValid.global ? (
                        <CheckCircleOutline sx={{ position: 'relative', top: '5px' }} color="primary" />
                      ) : (
                        <ErrorOutline sx={{ position: 'relative', top: '5px' }} color="error" />
                      )}
                    </h3>
                    {globalUser?.users && Array.isArray(globalUser?.users) && globalUser?.users?.length && (
                      <>
                        <Table stickyHeader aria-label="sticky table" fullWidth sx={{ ...theme.typography.customInput }}>
                          <EnhancedTableEmployeeDetailsHead />
                          <TableBody>
                            {globalUser?.users?.map((itemEmp, index) => (
                              <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                {/* Employee Name */}
                                <TableCell
                                  align="center"
                                  sx={{
                                    width: '50%',
                                    padding: '16px'
                                  }}
                                >
                                  <Typography
                                    component={'p'}
                                    variant="h5"
                                    sx={{ fontWeight: '600', marginRight: '4px', minWidth: '200px' }}
                                  >
                                    {itemEmp?.firstName} {itemEmp?.lastName}
                                  </Typography>
                                  <Typography
                                    component={'p'}
                                    variant="h5"
                                    sx={{ fontWeight: '500', marginRight: '4px', minWidth: '200px' }}
                                  >
                                    <span
                                      style={{
                                        fontSize: '13px'
                                      }}
                                    >
                                      {itemEmp?.email}
                                    </span>
                                  </Typography>
                                  {/* <Typography
                            component={'p'}
                            variant="h5"
                            sx={{ fontWeight: '500', marginRight: '4px', minWidth: '200px', fontSize: '13px' }}
                          >
                            Organization Types:{' '}
                            <span
                              style={{
                                fontSize: '13px'
                              }}
                            >
                              {itemEmp?.organizationTypes?.length ? itemEmp?.organizationTypes?.join(', ') : 'N.A.'}
                            </span>
                          </Typography> */}
                                </TableCell>

                                {/* Autocomplete with Formik */}
                                <TableCell
                                  align="center"
                                  sx={{
                                    width: '50%',
                                    padding: '16px'
                                    //   borderBottom: '1px solid #e0e0e0'
                                  }}
                                  className="org-edit-model"
                                >
                                  {/* Remove Icon  */}
                                  <Button
                                    disableElevation
                                    size="medium"
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => onRemoveUser(itemEmp?.id, 'global')}
                                    className="machineViewBtn"
                                    style={{ backgroundColor: 'rgb(229 59 59)' }}
                                  >
                                    <PersonRemove /> &nbsp; Remove
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        <Divider sx={{ pt: 2, pb: 2 }} />
                      </>
                    )}
                  </Grid>
                )}
                {localUser && (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <h2>Local User </h2>
                    <h3 style={{ marginBottom: 0, marginTop: '5px' }}>Current Plan Count : {localUser?.previousLocalUserCount}</h3>
                    <h3 style={{ marginBottom: 0, marginTop: '5px' }}>Chosen Plan Count : {localUser?.currentLocalUserCount}</h3>
                    <h3 style={{ marginBottom: 0, marginTop: '5px' }}>
                      You need to remove {localUser?.localUserCountDifference} user(s) from this list &nbsp;{' '}
                      {isValid.local ? (
                        <CheckCircleOutline sx={{ position: 'relative', top: '5px' }} color="primary" />
                      ) : (
                        <ErrorOutline sx={{ position: 'relative', top: '5px' }} color="error" />
                      )}
                    </h3>
                    {localUser?.users && Array.isArray(localUser?.users) && localUser?.users?.length ? (
                      <>
                        <Table stickyHeader aria-label="sticky table" fullWidth sx={{ ...theme.typography.customInput }}>
                          <EnhancedTableEmployeeDetailsHead />
                          <TableBody>
                            {localUser?.users?.map((itemEmp, index) => (
                              <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                {/* Employee Name */}
                                <TableCell
                                  align="center"
                                  sx={{
                                    width: '50%',
                                    padding: '16px'
                                  }}
                                >
                                  <Typography
                                    component={'p'}
                                    variant="h5"
                                    sx={{ fontWeight: '600', marginRight: '4px', minWidth: '200px' }}
                                  >
                                    {itemEmp?.firstName} {itemEmp?.lastName}
                                  </Typography>
                                  <Typography
                                    component={'p'}
                                    variant="h5"
                                    sx={{ fontWeight: '500', marginRight: '4px', minWidth: '200px' }}
                                  >
                                    <span
                                      style={{
                                        fontSize: '13px'
                                      }}
                                    >
                                      {itemEmp?.email}
                                    </span>
                                  </Typography>
                                  {/* <Typography
                            component={'p'}
                            variant="h5"
                            sx={{ fontWeight: '500', marginRight: '4px', minWidth: '200px', fontSize: '13px' }}
                          >
                            Organization Types:{' '}
                            <span
                              style={{
                                fontSize: '13px'
                              }}
                            >
                              {itemEmp?.organizationTypes?.length ? itemEmp?.organizationTypes?.join(', ') : 'N.A.'}
                            </span>
                          </Typography> */}
                                </TableCell>

                                {/* Autocomplete with Formik */}
                                <TableCell
                                  align="center"
                                  sx={{
                                    width: '50%',
                                    padding: '16px'
                                    //   borderBottom: '1px solid #e0e0e0'
                                  }}
                                  className="org-edit-model"
                                >
                                  {/* Remove Icon  */}
                                  <Button
                                    disableElevation
                                    size="medium"
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => onRemoveUser(itemEmp?.id, 'local')}
                                    className="machineViewBtn"
                                    style={{ backgroundColor: 'rgb(229 59 59)' }}
                                  >
                                    <PersonRemove /> &nbsp; Remove
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        <Divider sx={{ pt: 2, pb: 2 }} />
                      </>
                    ) : // <h3 style={{ marginTop: '5px' }}>No Users</h3>
                    null}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <DialogActions>
            {errors.submit && (
              <Box sx={{ mt: 3 }}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Box>
            )}
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button
                fullWidth
                variant="contained"
                type="submit"
                style={{
                  color: '#fff'
                }}
                color="primary"
                disabled={isLoadingCallChangeSubscriptonUser ? true : isValid.global && isValid.local ? false : true}
              >
                Save
                {isLoadingCallChangeSubscriptonUser && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: '#16B1FF',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px'
                    }}
                  />
                )}
              </Button>
            </Box>
            <Button variant="outlined" type="reset" color="error" onClick={handleClose}>
              Cancel
            </Button>
          </DialogActions>
        </Form>
      )}
    </>
  );
};

export default SubscriptionChangeModalForm;
